import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-box-thermostat',
    templateUrl: './box-thermostat.component.html',
    styleUrls: ['./box-thermostat.component.scss'],
    standalone: false
})
export class BoxThermostatComponent implements OnInit {

    @Input() title: string | undefined;
    @Input() currentMode: string | undefined;
    @Input() currentUmidity: number | undefined;
    @Input() currentTemperature: number | undefined;
    @Input() settingTemperature: number | undefined;
    @Input() loadValue: boolean | undefined;
    @Output() clickOpenThermostat: EventEmitter<{ thermostat: any }> = new EventEmitter();
    @Output() clickSettings: EventEmitter<{ thermostat: any }> = new EventEmitter();

    constructor(
        iconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
    ) {
        iconRegistry.addSvgIcon(
            'termomether',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/temperature/termomether.svg'));
        iconRegistry.addSvgIcon(
            'dropPlusMinus',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/button/dropPlusMinus.svg'));
        iconRegistry.addSvgIcon(
            'greenEnergy',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/energy/sun-with-plug.svg'));
    }

    ngOnInit(): void {
    }


    openThermostat(thermostat: any | undefined): void {
        this.clickOpenThermostat.next({thermostat: thermostat});
    }

    openSettings(): void {
        if (!this.loadValue) {
            this.clickSettings.emit();
        }
    }

}
